import { DspBean, DspControllerApi, DomainCategoryControllerApi, ItemResponseDspBeanObject, ListResponseDspBean, ClusterKeyValue } from 'src/api/api';
import { BaseApi, configuration } from '../../../api/BaseApi';
import { processError } from '../../../api/customFetch';
import { env } from '../../../env';

class DspApi extends BaseApi {
    api: DspControllerApi;
    exchangeApi: DspControllerApi;
    domainCategoryApi: DomainCategoryControllerApi;

    constructor() {
        super();
        this.api = new DspControllerApi(configuration, configuration.basePath, this.customFetch);
        this.exchangeApi = new DspControllerApi(configuration, env.exchange, this.customFetch);
        this.domainCategoryApi = new DomainCategoryControllerApi(configuration, configuration.basePath, this.customFetch);
    }

    list(miniExchange: boolean = false, size: number = 20, page: number = 1, search?): Promise<ListResponseDspBean> {

        if (!miniExchange) {
            return this.api.dspList(search, {query: { size, page }})
                .then(list => {
                    return Promise.resolve(list);
                }).catch(err => {
                    return processError(err);
                });
        } else {
            return this.api.miniExchangeList(search, {query:{ size, page }})
                .then(list => {
                    return Promise.resolve(list);
                }).catch(err => {
                    return processError(err);
                });
        }
    }

    all(): Promise<ListResponseDspBean> {
        return this.api.all().then(list => {
            return Promise.resolve(list);
        }).catch(err => {
            return processError(err);
        });
    }

    create(dsp: DspBean): Promise<ItemResponseDspBeanObject> {
        return this.api.createDsp(dsp).then(created => {
            return Promise.resolve(created);
        }).catch(err => {
            return processError(err);
        });
    }

    edit(id: number, dsp: DspBean): Promise<ItemResponseDspBeanObject> {
        return this.api.editDsp(dsp, id).then(updated => {
            return Promise.resolve(updated);
        }).catch(err => {
            return processError(err);
        });
    }

    view(id): Promise<ItemResponseDspBeanObject> {
        return this.api.dsp(id).then(dsp => {
            return Promise.resolve(dsp);
        }).catch(err => {
            return processError(err);
        });
    }

    delete(id: number): Promise<void> {
        return this.api.deleteDsp(id).then(() => {
            return Promise.resolve();
        }).catch(err => {
            return processError(err);
        });
    }

    async searchDomainCategories(search: string = ''): Promise<any> {
        try {
            const result = await this.domainCategoryApi.searchDomainCategories(search);
            return Promise.resolve(result);
        } catch (err) {
            return processError(err);
        }
    }

    async getDomainsByCategories(categoryIds: number[]): Promise<any> {
        try {
            const result = await this.domainCategoryApi.getDomainsByCategories(categoryIds);
            return Promise.resolve(result);
        } catch (err) {
            return processError(err);
        }
    }

    async getMobileAppIdsByCategories(categoryIds: number[]): Promise<any> {
        try {
            const result = await this.domainCategoryApi.getMobileAppIdsByCategories(categoryIds);
            return Promise.resolve(result);
        } catch (err) {
            return processError(err);
        }
    }

    async getClusterEndpoints(): Promise<Array<ClusterKeyValue>> {
        try {
            const result = await this.exchangeApi.clustersList();
            return Promise.resolve(result);
        } catch (err) {
            return processError(err);
        }
    }

    async getDashboardConfig(id: number): Promise<any> {
        try {
            const result = await this.api.getDashboardConfig(id);
            return Promise.resolve(result);
        } catch (err) {
            return processError(err);
        }
    }

    async getDashboardConfigOptions(): Promise<any> {
        try {
            const result = await this.api.getDashboardConfigOptions();
            return Promise.resolve(result);
        } catch (err) {
            return processError(err);
        }
    }

    async getDashboardApiKey(id?: number | null): Promise<any> {
        try {
            const result = await this.api.getDashboardApiKey(id);
            return Promise.resolve(result);
        } catch (err) {
            return processError(err);
        }
    }
}

const dspApi = new DspApi();

export default dspApi;
